module.exports = __webpack_public_path__ + "static/img/recommend-list-5.368bd8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/recommend-list-5.png
// module id = i9sf
// module chunks = 1